window.DSD_TOTAL_ORDERS=4067;
/* DIX 2026 : le compteur « clients » de l'accueil affiche 5000 (demande de Jay, juillet 2026). */
window.DSD_CLIENTS_COUNT=5000;
(function(){function p(){var e=document.getElementById('statClients');if(e){e.setAttribute('data-count',String(window.DSD_CLIENTS_COUNT));}}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',p);}else{p();}})();

/* DIX 2026 : le message de stock de Vitals (« Faites vite ! Il ne reste plus que X unités… »)
   s'affiche en gris foncé, illisible sur fond noir. Vitals injecte ce bloc après coup et son
   nom de classe change — on le repère donc par son texte et on force une couleur lisible. */
(function(){
  var RE=/(Faites vite|unités? en stock|unités? restante|units? left|left in stock|in stock)/i;
  var COLOR='#f5f3ef';
  function paint(){
    var nodes=document.querySelectorAll('body *');
    for(var i=0;i<nodes.length;i++){
      var el=nodes[i];
      if(el.dataset.dsdStockFix)continue;
      if(el.children.length>2)continue;
      var t=(el.textContent||'').trim();
      if(t.length<6||t.length>160)continue;
      if(!RE.test(t))continue;
      el.dataset.dsdStockFix='1';
      el.style.setProperty('color',COLOR,'important');
      var kids=el.querySelectorAll('*');
      for(var k=0;k<kids.length;k++){
        var c=kids[k];
        var cs=window.getComputedStyle(c);
        if(cs.backgroundColor&&cs.backgroundColor!=='rgba(0, 0, 0, 0)')continue;
        if(!(c.textContent||'').trim())continue;
        c.style.setProperty('color',COLOR,'important');
      }
    }
  }
  function start(){
    paint();
    if('MutationObserver' in window){
      var mo=new MutationObserver(function(){paint();});
      mo.observe(document.body,{childList:true,subtree:true});
      setTimeout(function(){mo.disconnect();},20000);
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start);}else{start();}
})();
